import React, { useEffect, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useSearchParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight, CalendarDays, Users, Grid3X3, Handshake, Heart, Mic, Trophy, X } from 'lucide-react';

// ============================================================
// ⚠️ IMPORT DE TOUTES LES PHOTOS DU DOSSIER /assets/networking/
// ============================================================

// Événements MCE
import event1 from '../assets/networking/event1.jpeg';
import partageSavoirGofar from '../assets/networking/partage-savoir-gofar.jpg';
import sessionTravailMce from '../assets/mce.jpeg';
// Atelier du Pardon
import atelierPardon from '../assets/networking/atelierdupardon.jpeg';

import aberkane1 from '../assets/networking/event1.jpeg';
import aberkane2 from '../assets/networking/event1.jpeg';

// Inspiration / Gala / Portraits
import inspi1 from '../assets/networking/inspi1.jpeg';
import inspi2 from '../assets/networking/inspi2.jpeg';
import inspi3 from '../assets/networking/inspi3.jpeg';
import inspi7 from '../assets/networking/inspi7.jpeg';
import inspi8 from '../assets/networking/inspi8.jpeg';
import inspi10 from '../assets/networking/inspi10.jpeg';
import inspi11 from '../assets/networking/inspi11.jpeg';
import inspi12 from '../assets/networking/inspi12.jpeg';

// ============ NOUVEAUX AJOUTS ============
// Équipe
import equipe2 from '../assets/networking/equipe2.jpeg';
// Interview (magazine étoile africaine + presse)
import interview2 from '../assets/networking/interview2.png';
import interview3 from '../assets/networking/interview3.png';
import interview4 from '../assets/networking/interview4.jpeg';
// STAY UP
import remisePrixStayup from '../assets/networking/remise-prix-stayup.png';
import stayup6 from '../assets/networking/stayup6.jpeg';
import stayup7 from '../assets/networking/stayup7.jpeg';
// Sport
import sport9 from '../assets/networking/sport9.jpeg';

// Volet social & solidarité
import social2 from '../assets/networking/social2.jpeg';
import social3 from '../assets/networking/social3.jpeg';
import kebaSignature from '../assets/networking/keba-signature.jpg';

// Sport & team building
import sport1 from '../assets/networking/sport1.jpeg';
import sport2 from '../assets/networking/sport2.jpeg';
import sport3 from '../assets/networking/sport3.jpeg';
import sportEffort from '../assets/networking/sport-effort.png';
import sportPartage from '../assets/networking/sport-partage.png';

// Forum Stayup 2025
import stayip1 from '../assets/networking/stayip1.jpeg';
import afterworkGofar from '../assets/networking/afterwork-gofar.jpg';

// Femmes leaders & entrepreneuriat féminin
import women1 from '../assets/networking/women1.jpg';
import women2 from '../assets/networking/women2.jpg';
import socialEnfantImpact from '../assets/networking/social-enfant-impact.png';

// ============ NOUVELLES PHOTOS (dispatch par nomenclature) ============
// Événement Idriss Aberkane
import idrissberkane from '../assets/networking/idrissberkane.jpeg';
// Interview
import interviewMce from '../assets/networking/interview.jpeg';
// Partenaire Keba Consulting
import kebaPhoto from '../assets/networking/keba.jpeg';
import keba2Photo from '../assets/networking/keba2.jpeg';
// Social
import socialNew from '../assets/networking/social.jpeg';
// Sport
import sportNew from '../assets/networking/sport.jpeg';
import sport5 from '../assets/networking/sport5.jpeg';
import sport6 from '../assets/networking/sport6.jpeg';
import sport7 from '../assets/networking/sport7.jpeg';
// Événement Stay Up
import stayupNew from '../assets/networking/stayup.jpeg';
import stayup3 from '../assets/networking/stayup3.jpeg';
// Partenaire Wellness Africa
import wellness1 from '../assets/networking/wellness1.jpeg';
import wellness2 from '../assets/networking/wellness2.jpeg';
import wellness3 from '../assets/networking/wellness3.jpeg';
// Nouvelles photos
const NEW_GALLERY_ITEMS = [
  { id: 'new-04', title: 'Créer des connexions, faire émerger les talents', subtitle: 'Lors de Stay Up 2025, MCE prend part à un temps fort d’échanges et de rencontres, aux côtés d’acteurs engagés pour l’entrepreneuriat, l’innovation et les initiatives à impact', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: require('../assets/networking/WhatsApp Image 2026-08-24 at 12.32.26 (1).jpeg') },
  { id: 'new-05', title: 'Le numérique en débat', subtitle: 'Panel Stay-Up', description: 'Des échanges pour mieux comprendre les enjeux et les perspectives du numérique.', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: require('../assets/networking/WhatsApp Image 2026-08-24 at 12.32.26.jpeg') },
  { id: 'new-09', title: 'Bouger, découvrir, créer du lien', subtitle: 'MCE partage aussi des moments sportif et convivial avec les Hashers (On On) : une autre façon de renforcer les liens, découvrir Dakar et vivre l’esprit de groupe. ', category: 'Sport', image: require('../assets/networking/sport9.jpeg'), objectPosition: 'center 30%' },
  { id: 'new-14', title: 'Des idées qui bousculent, des rencontres qui ouvrent les perspectives', subtitle: '', description: 'À l’occasion du forum des batisseurs avec Idriss Aberkane, MCE participe à un temps d’échange autour de l’innovation, de l’entrepreneuriat et des nouvelles façons de penser l’avenir.', eventType: 'Sparks Project', category: 'Événements', partner: 'Sparks Project', image: require('../assets/networking/WhatsApp Image 2026-08-24 at 12.32.29 (2).jpeg') },
  { id: 'new-15', title: 'Loman art : Quand les femmes entreprennent, les idées deviennent mouvement ', subtitle: 'Au Loman Art, la fondatrice de MCE, Mme Amane Mounia, partage son expérience et son engagement pour soutenir l’entrepreneuriat des femmes africaines et encourager leur rôle dans la transformation économique du continent.', category: 'Événements', eventType: 'GoFar', partner: 'GoFar Holding', image: require('../assets/networking/partage-savoir-gofar.jpg') },
  { id: 'new-16', title: 'Les voix du collectif', subtitle: 'MCE & GoFar Holding', description: 'Des femmes engagées prennent la parole et mettent leurs idées au service d’une ambition commune.', category: 'Événements', eventType: 'GoFar', partner: 'GoFar Holding', image: require('../assets/networking/WhatsApp Image 2026-08-24 at 12.32.30 (1).jpeg') },
   { id: 'new-16b', title: 'Les voix du collectif', subtitle: 'MCE & GoFar Holding', description: 'Des femmes engagées prennent la parole et mettent leurs idées au service d’une ambition commune.', category: 'Événements', eventType: 'GoFar', partner: 'GoFar Holding', image: require('../assets/networking/women2.jpg') },
  { id: 'new-17', title: 'Là où l’espoir prend racine', subtitle: 'Les racines de l Espoir', description: 'Aux côtés de Sophie Gueye et de l’association Les Racines de l’Espoir, MCE réaffirme son engagement pour l’enfance, la solidarité et les initiatives qui créent un impact humain concret.', category: 'Social', image: require('../assets/networking/WhatsApp Image 2026-08-24 at 12.32.31.jpeg') },
  { id: 'new-20', title: 'Marcher, découvrir, se retrouver', subtitle: 'Sport et découverte à Dakar', description: 'Une activité collective qui associe mouvement, découverte culturelle et esprit d’équipe.', category: 'Sport', image: require('../assets/networking/WhatsApp Image 2026-08-24 at 12.32.32.jpeg') },
  { id: 'new-21', title: 'Le numérique en débat', subtitle: 'Panel Stay-Up', description: 'Un panel réuni pour confronter les points de vue et construire les solutions de demain.', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: require('../assets/networking/WhatsApp Image 2026-08-24 at 12.32.32 (1).jpeg') },
  { id: 'new-22', title: 'Le numérique en débat', subtitle: 'Panel Stay-Up', description: 'Des acteurs engagés réunis autour des usages, des défis et du potentiel du numérique.', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: require('../assets/networking/WhatsApp Image 2026-08-24 at 12.32.33.jpeg') },
];

// ============================================================
// FILTRES PRINCIPAUX
// ============================================================
// ============================================================
// FILTRES PRINCIPAUX
// ============================================================
const FILTERS = [
  ['Tous', Grid3X3],
  ['Événements', CalendarDays],
  ['Équipe', Users],
  ['Social', Heart],
  ['Sport', Trophy],
  ['Interview', Mic],
];

const EVENT_TYPES = [
  'Tous les événements',
  'Keba Consulting',
  'STAY UP',
  'GoFar',
  'Sparks Project',
  'Wellness',
];


// ============================================================
// ITEMS DE LA GALERIE
// ============================================================
const ITEMS = [
  ...NEW_GALLERY_ITEMS.map(item => ({ ...item, size: 'standard' })),

  // ============ ÉVÉNEMENTS ============
 
  { id: 'ab-01', title: 'Forum Idriss Aberkane à Dakar', subtitle: 'Au Grand Théâtre National', description: 'Une conférence marquante sur l\'économie de la connaissance.', category: 'Événements', eventType: 'Sparks Project', partner: 'Sparks Project', image: aberkane1, size: 'standard' },
  { id: 'ev-05', title: 'Stay-Up 2025', subtitle: 'Cérémonie de remise de prix', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: stayip1, size: 'tall', objectPosition: 'top' },
 { id: 'ev-07', title: 'Mme AMANE Mounia au Forum des Bâtisseurs avec IDRISS ABERKANE', category: 'Événements', eventType: 'Sparks Project', partner: 'Sparks Project', image: inspi7, size: 'tall', objectPosition: 'top' },
  { id: 'ev-08', title: 'Collaboration entre MCE Sénégal & GoFar Holding', description: 'Entretien autour de la Femme Africaine', category: 'Événements', eventType: 'GoFar', partner: 'GoFar Holding', image: afterworkGofar, size: 'tall' },
  { id: 'ev-09', title: 'Un moment de partage de savoir', subtitle: 'Chaque apprentissage est une pierre posée sur le chemin de l’excellence.', description: 'Avec la Directrice de MCE', category: 'Événements', eventType: 'GoFar', partner: 'GoFar Holding', image: partageSavoirGofar, size: 'tall' },
  { id: 'ev-10', title: 'Session de travail avec l’équipe de MCE', description: 'Des esprits engagés, une vision commune, des résultats à construire.', category: 'Événements', image: sessionTravailMce, size: 'tall', objectPosition: 'top' },

  // ============ NOUVEAUX ÉVÉNEMENTS (Idriss Aberkane + Stay Up) ============
  { id: 'ev-11', title: 'Conférence magistrale d’Idriss Aberkane à Dakar', subtitle: 'MCE partenaire de l’événement', description: 'Un rendez-vous d’exception au Grand Théâtre National de Dakar, aux côtés de la fondatrice de MCE.', category: 'Événements', eventType: 'Sparks Project', partner: 'Sparks Project', image: idrissberkane, size: 'tall', objectPosition: 'center 80%' },
  { id: 'ev-12', title: 'Stay Up Awards — Un moment d’excellence panafricaine', subtitle: 'Mounia Amane, Présidente MCE', description: 'MCE présente lors de la remise des prix Stay Up 2025, un programme dédié à l’expertise africaine.', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: stayupNew, size: 'tall', objectPosition: 'top' },
  { id: 'ev-13', title: 'Stay Up 2025 — Un instant de reconnaissance', subtitle: 'Sur scène pour honorer les talents', description: 'Un moment fort de célébration et de valorisation des acteurs qui font rayonner le continent.', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: stayup3, size: 'standard' },

  { id: 'ev-14', title: 'Remise du trophée Stay Up 2025', subtitle: 'Célébrer les acteurs qui font bouger le continent', description: 'Un moment de reconnaissance porté par MCE aux côtés des lauréats et partenaires du programme Stay Up.', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: remisePrixStayup, size: 'tall', objectPosition: 'center 30%' },
  { id: 'ev-15', title: 'Stay Up 2025 — Un public engagé', subtitle: 'Une salle vibrante d\u2019énergie panafricaine', description: 'Des acteurs venus de tout le continent, réunis autour d\u2019une même ambition : faire rayonner l\u2019expertise africaine.', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: stayup6, size: 'wide' },
  { id: 'ev-16', title: 'L\u2019émotion des lauréats Stay Up', subtitle: 'Un instant qui restera gravé', description: 'Derrière chaque récompense, une histoire, un parcours, une famille et une communauté qui célèbrent.', category: 'Événements', eventType: 'STAY UP', partner: 'GoFar Holding', image: stayup7, size: 'standard' },
  // ============ ÉVÉNEMENTS — SPARKS PROJECT ============
{
  id: 'pa-sparks',
  title: 'Sparks Project & MCE',
  subtitle: 'Un partenariat pour révéler l’économie réelle',
  description:
    'Aux côtés de Sparks Project, MCE accompagne les porteurs de projets et met en lumière les acteurs qui font émerger la création de valeur en Afrique.',
  category: 'Événements',
  eventType: 'Sparks Project',
  partner: 'Sparks Project',
  image: inspi8,
  size: 'tall',
  objectPosition: 'top',
},

// ============ ÉVÉNEMENTS — GOFAR / WOMEN BUILDING AFRICA ============
{
  id: 'pa-01',
  title: 'Ensemble pour transformer les ambitions en résultats.',
  subtitle: 'Women Building Africa & MCE Sénégal',
  category: 'Événements',
  eventType: 'GoFar',
  partner: 'GoFar Holding',
  image: women1,
  size: 'tall',
},

// ============ ÉVÉNEMENTS — KEBA / ATELIER DU PARDON ============
{
  id: 'pa-02',
  title: 'Deux expertises. Une ambition commune.',
  subtitle: 'Un partenariat stratégique au service de votre réussite',
  description: 'Keba Consulting & MCE Sénégal',
  category: 'Événements',
  eventType: 'Keba Consulting',
  partner: 'Keba Consulting',
  image: kebaSignature,
  size: 'tall',
  objectPosition: 'top',
},

{
  id: 'pa-keba-01',
  title: 'Signature d’un partenariat structurant',
  subtitle: 'Keba Consulting & MCE Sénégal',
  description:
    'Un engagement fort pour accompagner les entreprises dans leur transformation et leur développement.',
  category: 'Événements',
  eventType: 'Keba Consulting',
  partner: 'Keba Consulting',
  image: kebaPhoto,
  size: 'standard',
  objectPosition: 'center 25%',
},

{
  id: 'pa-keba-02',
  title: 'Un partenariat qui prend forme',
  subtitle: 'MCE & Keba Consulting',
  description:
    'La formalisation d’une collaboration au service du développement humain et professionnel.',
  category: 'Événements',
  eventType: 'Keba Consulting',
  partner: 'Keba Consulting',
  image: keba2Photo,
  size: 'standard',
  objectPosition: 'top',
},

// ============ ÉVÉNEMENTS — WELLNESS ============
{
  id: 'pa-wellness-01',
  title: 'MCE & Wellness Africa — Un partenariat pour le bien-être',
  subtitle: 'Ensemble pour promouvoir la santé et le bien-être en Afrique',
  description:
    'Un partenariat qui unit expertise et engagement pour accompagner les entreprises et les particuliers dans une démarche de bien-être durable.',
  category: 'Événements',
  eventType: 'Wellness',
  partner: 'Wellness Africa',
  image: wellness1,
  size: 'tall',
  objectPosition: 'top',
},

{
  id: 'pa-wellness-02',
  title: 'Wellness Africa — Une alliance porteuse d’impact',
  subtitle: 'MCE aux côtés de Wellness Africa',
  description:
    'Deux structures engagées, une vision commune : celle d’un accompagnement qui valorise autant la performance que le bien-être.',
  category: 'Événements',
  eventType: 'Wellness',
  partner: 'Wellness Africa',
  image: wellness2,
  size: 'standard',
},
{
  id: 'pa-wellness-03',
  title: 'Wellness Africa — Une alliance porteuse d’impact',
  subtitle: 'MCE aux côtés de Wellness Africa',
  description:
    'Deux structures engagées, une vision commune : celle d’un accompagnement qui valorise autant la performance que le bien-être.',
  category: 'Événements',
  eventType: 'Wellness',
  partner: 'Wellness Africa',
  image: wellness3,
  size: 'standard',
},

  // ============ SOCIAL ============
  { id: 'so-03', title: 'Une journée avec Empire des Enfants', subtitle: 'MCE - La Solidarité en Action', category: 'Social', image: social3, size: 'standard' },
  { id: 'so-07', title: 'La solidarité au quotidien', subtitle: 'Distribuer, partager, transmettre', description: 'Dans les rues de Dakar, la fondatrice de MCE prend part à un moment de solidarité et de partage avec les populations vulnérables.', category: 'Social', image: socialNew, size: 'tall', objectPosition: 'center 30%' },

  // ============ ÉQUIPE ============
  { id: 'so-04', title: 'Au cœur de l’action, au plus près de nos clients ', subtitle: 'Dans nos locaux à Dakar, les équipes MCE se réunissent, analysent les besoins et construisent ensemble des solutions concrètes pour chaque projet. ', category: 'Équipe', image: sessionTravailMce, size: 'tall', objectPosition: 'top'},
  // ============ SPORT ============
  { id: 'sp-01', title: 'Cohésion par le sport', subtitle: 'Équipe & fair-play', category: 'Sport', image: sport1, size: 'wide' },
  { id: 'sp-02', title: 'Dépassement collectif', subtitle: 'Endurance & ambition', category: 'Sport', image: sport2, size: 'standard' },
  { id: 'sp-03', title: 'L\'énergie du terrain', subtitle: 'Team building actif', category: 'Sport', image: sport3, size: 'wide' },
  { id: 'sp-04', title: 'Unis par le sport, renforcés par l’effort', subtitle: 'Une occasion de se dépasser, de s’amuser et de construire un esprit d’équipe solide.', category: 'Sport', image: sportEffort, size: 'tall' },
  { id: 'sp-05', title: 'Pause, partage et bonne humeur', subtitle: 'Au-delà des missions, ce sont les liens humains qui font la force d’une équipe.', category: 'Sport', image: sportPartage, size: 'wide' },
  { id: 'sp-06', title: 'Au coucher du soleil, l’esprit du Hash', subtitle: 'Complicité et découverte à Ngor', description: 'Un moment de convivialité et de partage sportif avec la communauté des Hash House Harriers.', category: 'Sport', image: sportNew, size: 'wide' },
  { id: 'sp-07', title: 'Ensemble face à l’océan', subtitle: 'Groupe uni, esprit d’équipe', description: 'Une sortie sportive qui réunit les énergies et célèbre la richesse humaine du collectif.', category: 'Sport', image: sport5, size: 'wide' },
  { id: 'sp-08', title: 'Sur les marches du Monument de la Renaissance', subtitle: 'Team building à Dakar', description: 'Une équipe qui se retrouve, se dépasse et se retrouve autour d’un lieu emblématique de la capitale.', category: 'Sport', image: sport6, size: 'wide' },
  { id: 'sp-09', title: 'Marcher, découvrir, s’émerveiller', subtitle: 'Balade collective à Dakar', description: 'Une marche partagée qui allie sport, découverte culturelle et bonne humeur.', category: 'Sport', image: sport7, size: 'wide' },
  { id: 'sp-10', title: 'Au pied du Monument de la Renaissance', subtitle: 'Souvenir collectif à Dakar', description: 'Une équipe rassemblée pour immortaliser un moment fort, entre sport, culture et esprit d\u2019équipe.', category: 'Sport', image: sport9, size: 'tall', objectPosition: 'center 30%' },
  // ============ ACTION SOCIALE (4e photo Social) ============
  { id: 'so-06', title: 'Un geste, un sourire, un impact', subtitle: 'Parce que chaque enfant mérite d’être valorisé, écouté et accompagné.', category: 'Social', image: socialEnfantImpact, size: 'tall' },

  // ============ INTERVIEW (nouvelle catégorie) ============
  { id: 'in-01', title: 'La fondatrice de MCE face à la caméra', subtitle: 'Interview exclusive', description: 'Face à WADR – West Africa Democracy Radio, Mounia Amane partage son parcours, sa vision et l’ambition de MCE au service de l’entrepreneuriat et du développement en Afrique.', category: 'Interview', image: interviewMce, size: 'tall', objectPosition: 'top' },
  { id: 'in-02', title: '« L\u2019audace d\u2019entreprendre au service de l\u2019humain »', subtitle: 'Étoile Africaine — #22 Mai-Juin 2026', description: 'Un portrait signé Étoile Africaine, où Mounia Amane revient sur son parcours, sa vision de l\u2019entrepreneuriat et l\u2019ambition de MCE au service de l\u2019humain.', category: 'Interview', image: interview2, size: 'tall', objectPosition: 'top' },
  { id: 'in-03', title: 'MCE en couverture d\u2019Étoile Africaine', subtitle: 'Les étoiles qui inspirent l\u2019Afrique', description: 'Mounia Amane, Fondatrice de MCE, mise à l\u2019honneur parmi les figures inspirantes du continent dans le numéro #22 du magazine Étoile Africaine.', category: 'Interview', image: interview3, size: 'tall', objectPosition: 'top' },
  { id: 'in-04', title: 'Sous les couleurs du Sénégal', subtitle: 'La Fondatrice de MCE en immersion', description: 'Un instant symbolique qui incarne l\u2019engagement panafricain de MCE et son ancrage profond au Sénégal.', category: 'Interview', image: interview4, size: 'wide', objectPosition: 'center 30%' },
  // ============ ATELIER DU PARDON ============
  { id: 'ev-06', title: 'Atelier autour du Pardon', description: 'Développement Personnel & Confiance', category: 'Événements', eventType: 'Keba Consulting', partner: 'Keba Consulting', image: inspi12, size: 'tall' },
  { id: 'fo-01', title: 'Atelier autour du Pardon', subtitle: 'MCE & Keba Consulting : Main dans la Main', category: 'Événements', eventType: 'Keba Consulting', partner: 'Keba Consulting', image: inspi1, size: 'tall', objectPosition: 'top'},
  { id: 'fo-03', title: 'Au-delà du partenariat, c’est une transmission de savoir.', description: 'MCE & Keba Consulting : Main dans la Main', category: 'Événements', eventType: 'Keba Consulting', partner: 'Keba Consulting', image: inspi11, size: 'standard' },
  { id: 'fo-04', title: 'La Directrice de MCE avec l’équipe de Keba Consulting', subtitle: 'Atelier sur le Pardon.', description: 'Une période pour apprendre, une étape pour se révéler.', category: 'Événements', eventType: 'Keba Consulting', partner: 'Keba Consulting', image: inspi12, size: 'standard' },
  { id: 'fo-05', title: 'Atelier autour du Pardon — Un moment de partage authentique', subtitle: 'MCE & Keba Consulting', description: 'Un cercle de parole intime où chacun ose déposer ses émotions et retrouver la voie de la réconciliation avec soi-même.', category: 'Événements', eventType: 'Keba Consulting', partner: 'Keba Consulting', image: atelierPardon, size: 'tall', objectPosition: 'center 30%' },
];

const GALLERY_COPY = {
  'ev-01': ['Les bâtisseurs en mouvement', '', 'À Dakar, les idées deviennent des leviers de valeur.'],
  'ev-04': ['Le numérique en débat', 'Panel Stay-Up', 'Regards croisés sur les paysages de demain.'],
  'ev-05': ['L’excellence récompensée', 'Stay-Up 2025', 'Des talents mis en lumière et des parcours célébrés.'],
  'ev-06': ['Le courage de se pardonner', 'Atelier autour du pardon', 'Parler avec le cœur, déposer ce qui pèse et retrouver la force d’avancer. Un moment de partage pour se libérer, se réconcilier avec soi-même et retrouver confiance.'],
  'ev-07': ['Au cœur des bâtisseurs', 'Leadership en action', 'Mounia Amane porte la vision MCE sur la scène du forum.'],
  'ev-08': ['Des voix qui rassemblent', 'MCE & GoFar Holding', 'Un échange inspirant autour de la femme africaine — by Women Build Africa.'],
  'ev-09': ['Partager pour progresser', 'Transmission de savoir', 'Chaque apprentissage nous rapproche de l’excellence.'],
  'ev-10': ['Une vision, une équipe', 'Session de travail MCE', 'Des idées alignées pour construire des résultats durables.'],
  'pa-sparks': ['Sparks Project & MCE', 'Un partenariat pour révéler l’économie réelle', 'Aux côtés de Sparks Project, MCE accompagne les porteurs de projets et met en lumière les acteurs qui font émerger la création de valeur en Afrique.'],
  'pa-01': ['Quand deux fondatrices se rencontrent', ' Women Building Africa & MCE', 'Deux parcours, une même énergie : celle de l’audace et du lien.'],
  'pa-02': ['Deux expertises, une ambition commune ', 'Keba Consulting & MCE', 'MCE et Kéba Consulting unissent leurs forces autour d’un partenariat fondé sur la complémentarité, la transmission et la création de projets à impact.'],
  'pa-04': ['L’équipe derrière l’impact', 'MCE Sénégal', 'Des talents engagés pour faire vivre chaque expérience.'],
  'so-02': ['Au plus près des communautés', 'MCE sur le terrain', 'Écouter, comprendre et agir là où l’impact compte.'],
  'so-03': ['Des sourires qui comptent', 'Empire des Enfants', 'Une journée solidaire placée sous le signe du partage.'],
  'so-04': ['Au cœur de l’action, au plus près de nos clients ', 'L’équipe en action', 'Dans nos locaux à Dakar, les équipes MCE se réunissent, analysent les besoins et construisent ensemble des solutions concrètes pour chaque projet. '],
  'so-05': ['Créer plus de valeur', 'MCE & GoFar Holding', 'Une alliance au service des entreprises et des territoires.'],
  'sp-01': ['Plus forts ensemble', 'Cohésion par le sport', 'Le terrain révèle l’esprit d’équipe.'],
  'sp-02': ['Dépasser ses limits', 'Endurance collective', 'L’effort partagé transforme l’ambition en énergie.'],
  'sp-03': ['L’énergie du collectif', 'Team building actif', 'Bouger, coopérer et gagner en cohésion.'],
  'sp-04': ['Unis dans l’effort', 'Sport et dépassement', 'Une équipe soudée va toujours plus loin.'],
  'sp-05': ['La force des liens', 'Pause et partage', 'La convivialité nourrit aussi la performance.'],
  'so-06': ['Un geste, un impact', 'L’enfance au cœur', 'Valoriser chaque enfant pour ouvrir de nouveaux possibles.'],
  'fo-01': ['Apprendre à avancer', 'Atelier autour du pardon', 'MCE et Keba Consulting accompagnent la transformation.'],
  'fo-02': ['La jeunesse imagine demain', 'Rencontre à l’UCAD', 'Des échanges pour inspirer une génération d’acteurs.'],
  'fo-03': ['Transmettre pour élever', 'MCE & Keba Consulting', 'Le savoir partagé devient une force collective.'],
  'fo-04': ['Révéler les potentiels', 'Formation et transformation', 'Une expérience pour apprendre, évoluer et s’affirmer.'],
};

const GALLERY_ITEMS = ITEMS.map(item => {
  const [title, subtitle, description] = GALLERY_COPY[item.id] || [item.title, item.subtitle, item.description];
  return { ...item, title, subtitle, description };
});

const THUMBS_PER_PAGE = 6;

// ============================================================
// COMPOSANT PRINCIPAL
// ============================================================
export default function Galerie() {
const [searchParams] = useSearchParams();

const requestedCategory = searchParams.get('category');
const requestedEventType = searchParams.get('eventType');

const [filter, setFilter] = useState(
  FILTERS.some(([name]) => name === requestedCategory)
    ? requestedCategory
    : 'Tous'
);

const [eventTypeFilter, setEventTypeFilter] = useState(
  EVENT_TYPES.includes(requestedEventType)
    ? requestedEventType
    : 'Tous les événements'
);

  const [thumbPage, setThumbPage] = useState(0);
  const [lightboxId, setLightboxId] = useState(null); // ID de la photo affichée en lightbox

  // Liste filtrée
 const visible = useMemo(() => {
  return GALLERY_ITEMS.filter(item => {
    const matchCategory =
      filter === 'Tous' || item.category === filter;

    const matchEventType =
      filter !== 'Événements' ||
      eventTypeFilter === 'Tous les événements' ||
      item.eventType === eventTypeFilter;

    return matchCategory && matchEventType;
  });
}, [filter, eventTypeFilter]);

  // === LA PHOTO EN VEDETTE EST FIXE : c'est la première photo de la catégorie ===
  const featuredItem = visible[0] || null;
  // Les autres photos vont dans la grille du bas (sans dupliquer la featured)
  const otherItems = visible.slice(1);

  // Reset pagination quand les filtres changent
  useEffect(() => {
  setThumbPage(0);
}, [filter, eventTypeFilter]);

  const totalPages = Math.max(1, Math.ceil(otherItems.length / THUMBS_PER_PAGE));
  const currentThumbs = otherItems.slice(thumbPage * THUMBS_PER_PAGE, (thumbPage + 1) * THUMBS_PER_PAGE);

  // === Lightbox ===
  const lightboxIndex = lightboxId ? visible.findIndex(i => i.id === lightboxId) : -1;
  const lightboxItem = lightboxIndex >= 0 ? visible[lightboxIndex] : null;

  const moveLightbox = (direction) => {
    if (lightboxIndex < 0) return;
    const nextIndex = (lightboxIndex + direction + visible.length) % visible.length;
    setLightboxId(visible[nextIndex].id);
  };

  // Navigation clavier dans la lightbox uniquement
  useEffect(() => {
    if (!lightboxItem) return;
    const onKey = (event) => {
      if (event.key === 'Escape') setLightboxId(null);
      if (event.key === 'ArrowLeft') moveLightbox(-1);
      if (event.key === 'ArrowRight') moveLightbox(1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lightboxItem, lightboxIndex, visible]);

  // Verrouille le scroll du body quand la lightbox est ouverte
  useEffect(() => {
    if (!lightboxItem) return;
    const originalOverflow = document.body.style.overflow;
    const originalPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.paddingRight = originalPaddingRight;
    };
  }, [lightboxItem]);

  return (
    <main className="pt-[72px] bg-[#0F1E3D] min-h-screen text-white relative overflow-hidden">
      {/* Halos décoratifs subtils */}
      <div className="absolute top-40 -left-32 w-96 h-96 rounded-full bg-[#00AEEF]/10 blur-3xl pointer-events-none" aria-hidden="true" />
      <div className="absolute bottom-40 -right-32 w-96 h-96 rounded-full bg-[#FFB800]/5 blur-3xl pointer-events-none" aria-hidden="true" />

      <section id="galerie" className="max-w-[1800px] mx-auto px-4 md:px-10 lg:px-16 py-10 md:py-16 relative">
        {/* ========== EN-TÊTE ========== */}
        <header className="mb-6">
          <h2 className="text-3xl md:text-4xl font-bold mb-3 text-white">
            Explorez les moments forts de MCE.
          </h2>
          <p className="text-white/60 max-w-3xl leading-relaxed text-sm md:text-base">
            Choisissez une catégorie et découvrez les projets, les rencontres et les énergies qui font vivre notre écosystème.
          </p>
        </header>

        {/* ========== FILTRES PRINCIPAUX ========== */}
        <nav className="flex flex-wrap items-center gap-1.5 mb-3" aria-label="Filtrer la galerie">
          {FILTERS.map(([item, Icon]) => (
            <button
              key={item}
              type="button"
              onClick={() => {
                setFilter(item);
                setEventTypeFilter('Tous les événements');
                setThumbPage(0);
              }}
              aria-pressed={filter === item}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                filter === item
                  ? 'bg-[#00AEEF] text-white shadow-sm shadow-[#00AEEF]/30'
                  : 'bg-white/5 text-white/60 hover:bg-white/10 hover:text-white ring-1 ring-white/10'
              }`}
            >
              <Icon className="w-3.5 h-3.5" />
              {item}
            </button>
          ))}
          <AnimatePresence>
            {(filter !== 'Tous' || eventTypeFilter !== 'Tous les événements') && (
              <motion.button
                type="button"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                onClick={() => {
                setFilter('Tous');
                setEventTypeFilter('Tous les événements');
                setThumbPage(0);
              }}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-white/5 text-white/50 hover:bg-white/10 hover:text-white transition"
              >
                <X className="w-3 h-3" /> Réinitialiser
              </motion.button>
            )}
          </AnimatePresence>
        </nav>

        {/* ========== SOUS-FILTRES ÉVÉNEMENTS ========== */}
        <AnimatePresence>
          {filter === 'Événements' && (
            <motion.nav
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="mb-3 flex flex-wrap gap-1.5 items-center overflow-hidden"
              aria-label="Filtrer par type d'événement"
            >
              <span className="text-xs text-white/40 mr-1">Type d'événement :</span>
              {EVENT_TYPES.map(type => (
                <button
                  key={type}
                  type="button"
                  onClick={() => { setEventTypeFilter(type); setThumbPage(0); }}
                  className={`px-2.5 py-1 rounded-full text-[11px] font-medium transition ${
                    eventTypeFilter === type
                      ? 'bg-[#FFB800] text-[#0F1E3D]'
                      : 'bg-white/5 text-white/50 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  {type}
                </button>
              ))}
            </motion.nav>
          )}
        </AnimatePresence>

        {/* ========== SOUS-FILTRES PARTENAIRES ========== */}
        <AnimatePresence>
          {filter === 'Partenaires' && (
            <motion.nav
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="mb-3 flex flex-wrap gap-1.5 items-center overflow-hidden"
              aria-label="Filtrer par partenaire"
            >
              <span className="text-xs text-white/40 mr-1">Partenaire spécifique :</span>
              {PARTNERS_LIST.map(partner => (
                <button
                  key={partner}
                  type="button"
                  onClick={() => { setPartnerFilter(partner); setThumbPage(0); }}
                  className={`px-2.5 py-1 rounded-full text-[11px] font-medium transition ${
                    partnerFilter === partner
                      ? 'bg-[#FFB800] text-[#0F1E3D]'
                      : 'bg-white/5 text-white/50 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  {partner}
                </button>
              ))}
            </motion.nav>
          )}
        </AnimatePresence>

        {/* Compteur d'images */}
        <p className="text-xs text-white/40 mb-10">
          <span className="font-bold text-white">{visible.length}</span> image{visible.length > 1 ? 's' : ''} correspondant à votre sélection
        </p>

        {featuredItem ? (
          <>
            {/* ========== PHOTO VEDETTE (FIXE PAR CATÉGORIE) + DESCRIPTION ========== */}
            <div className="grid grid-cols-1 lg:grid-cols-[1.55fr_1fr] gap-8 lg:gap-16 mb-14 items-center">
              {/* Image principale — cliquable pour ouvrir la lightbox */}
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] shadow-2xl shadow-black/40 group">
                <AnimatePresence mode="wait">
                  <motion.img
                    key={featuredItem.id}
                    src={featuredItem.image}
                    alt={featuredItem.title}
                    onClick={() => setLightboxId(featuredItem.id)}
                    style={{ objectPosition: featuredItem.objectPosition || 'center' }}
                    className="absolute inset-0 w-full h-full object-cover cursor-zoom-in transition-transform duration-500 group-hover:scale-[1.02]"
                    initial={{ opacity: 0, scale: 1.03 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.45 }}
                  />
                </AnimatePresence>
              </div>

              {/* Panneau texte descriptif */}
              <div>
                <AnimatePresence mode="wait">
                  <motion.div
                    key={featuredItem.id}
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -6 }}
                    transition={{ duration: 0.35 }}
                  >
                    <div
                      className="w-12 h-0.5 rounded-full mb-6"
                      style={{ background: 'linear-gradient(90deg, #00AEEF 0%, #FFB800 100%)' }}
                    />
                    <h1 className="text-3xl lg:text-4xl xl:text-5xl font-bold leading-tight mb-4 text-white">
                      {featuredItem.title}
                    </h1>
                    {featuredItem.subtitle && (
                      <p className="text-[#00AEEF] font-semibold text-base lg:text-lg mb-5">
                        {featuredItem.subtitle}
                      </p>
                    )}
                    {featuredItem.description && (
                      <p className="text-white/70 leading-relaxed mb-6 text-sm lg:text-base max-w-xl">
                        {featuredItem.description}
                      </p>
                    )}
                    <div className="flex flex-wrap gap-4 text-sm font-bold text-[#00AEEF]">
                      <span>#{featuredItem.category}</span>
                      {featuredItem.eventType && <span>#{featuredItem.eventType}</span>}
                      {featuredItem.partner && <span>#{featuredItem.partner}</span>}
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>

            {/* ========== MINIATURES (sans titre, ne changent PLUS la featured) ========== */}
            {otherItems.length > 0 && (
              <>
                <h3 className="text-white/60 text-sm font-semibold mb-4 uppercase tracking-wider">
                  Découvrir les autres moments
                </h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
                  <AnimatePresence mode="popLayout">
                    {currentThumbs.map((item, index) => (
                      <motion.button
                        key={item.id}
                        type="button"
                        onClick={() => setLightboxId(item.id)}
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -6 }}
                        transition={{ duration: 0.3, delay: index * 0.04 }}
                        className="relative text-left group focus:outline-none rounded-xl overflow-hidden aspect-[4/3] cursor-zoom-in"
                        aria-label={`Voir ${item.title} en grand`}
                      >
                        <img
                          src={item.image}
                          alt={item.title}
                          loading="lazy"
                          style={{ objectPosition: item.objectPosition || 'center' }}
                          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      </motion.button>
                    ))}
                  </AnimatePresence>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="flex justify-center items-center gap-2 mt-10">
                    {Array.from({ length: totalPages }).map((_, index) => (
                      <button
                        key={index}
                        type="button"
                        onClick={() => setThumbPage(index)}
                        aria-label={`Aller à la page ${index + 1}`}
                        aria-current={index === thumbPage ? 'page' : undefined}
                        className={`rounded-full transition-all ${
                          index === thumbPage
                            ? 'w-8 h-2 bg-[#00AEEF]'
                            : 'w-2 h-2 bg-white/20 hover:bg-white/40'
                        }`}
                      />
                    ))}
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          <div className="text-center py-24 bg-white/5 rounded-2xl border border-white/10">
            <X className="w-12 h-12 text-white/20 mx-auto mb-6" />
            <p className="text-lg text-white/50 font-medium">
              Aucune image ne correspond aux filtres sélectionnés.
            </p>
            <button
              onClick={() => {
                setFilter('Tous');
                setPartnerFilter('Tous les partenaires');
                setEventTypeFilter('Tous les événements');
              }}
              className="mt-6 text-sm text-[#00AEEF] hover:underline"
            >
              Réinitialiser les filtres
            </button>
          </div>
        )}
      </section>

      {/* ========== LIGHTBOX (visionneuse plein écran) ========== */}
      {/* ⚠️ SORTIE DE <section> POUR ÉCHAPPER À TOUT CONTEXTE DE POSITIONNEMENT */}
      <AnimatePresence>
        {lightboxItem && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-sm"
            onClick={() => setLightboxId(null)}
            role="dialog"
            aria-modal="true"
            aria-label={lightboxItem.title}
          >
            {/* Conteneur flex qui remplit vraiment le viewport */}
            <div
              className="absolute inset-0 flex items-center justify-center"
              style={{
                paddingTop: 'max(1rem, env(safe-area-inset-top))',
                paddingBottom: 'max(1rem, env(safe-area-inset-bottom))',
                paddingLeft: 'max(1rem, env(safe-area-inset-left))',
                paddingRight: 'max(1rem, env(safe-area-inset-right))',
              }}
            >
              {/* Image — max-w-full max-h-full = le navigateur gère le ratio */}
              <img
                key={lightboxItem.id}
                src={lightboxItem.image}
                alt={lightboxItem.title}
                onClick={(e) => e.stopPropagation()}
                className="max-w-full max-h-full object-contain rounded-lg shadow-2xl select-none"
                draggable={false}
              />
            </div>

            {/* Bouton fermer */}
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); setLightboxId(null); }}
              aria-label="Fermer"
              className="absolute top-3 right-3 md:top-4 md:right-4 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition z-[110]"
            >
              <X className="w-5 h-5 md:w-6 md:h-6" />
            </button>

            {/* Bouton précédent */}
            {visible.length > 1 && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); moveLightbox(-1); }}
                aria-label="Image précédente"
                className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition z-[110]"
              >
                <ArrowLeft className="w-5 h-5 md:w-6 md:h-6" />
              </button>
            )}

            {/* Bouton suivant */}
            {visible.length > 1 && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); moveLightbox(1); }}
                aria-label="Image suivante"
                className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition z-[110]"
              >
                <ArrowRight className="w-5 h-5 md:w-6 md:h-6" />
              </button>
            )}

            {/* Légende discrète */}
            <div
              className="absolute bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 text-white text-xs md:text-sm text-center bg-black/60 backdrop-blur px-3 py-1.5 md:px-4 md:py-2 rounded-full max-w-[85vw] truncate z-[110]"
              onClick={(e) => e.stopPropagation()}
            >
              {lightboxItem.title}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </main>
  );
}